import { ChevronLeft, ChevronRight } from "lucide-react";
import { monthLabel } from "../lib/api";

export const shiftMonth = (m, n) => {
  let y = Number(m.slice(0, 4));
  let mo = Number(m.slice(5, 7)) + n;
  while (mo > 12) { mo -= 12; y += 1; }
  while (mo < 1) { mo += 12; y -= 1; }
  return `${y}-${String(mo).padStart(2, "0")}`;
};

export const MonthNav = ({ month, onChange, testid = "month-nav" }) => (
  <div className="flex items-center gap-3 flex-wrap" data-testid={testid}>
    <button onClick={() => onChange(shiftMonth(month, -1))} data-testid={`${testid}-prev`}
      className="flex items-center gap-1 border border-[#D4AF37]/50 text-[#D4AF37] px-4 py-2.5 text-xs font-bold uppercase tracking-widest hover:bg-[#D4AF37] hover:text-black transition-colors duration-200">
      <ChevronLeft size={15} /> Prev
    </button>
    <p className="font-heading text-2xl sm:text-3xl font-black uppercase tracking-tight min-w-[190px] text-center" data-testid={`${testid}-label`}>
      {monthLabel(month)}
    </p>
    <button onClick={() => onChange(shiftMonth(month, 1))} data-testid={`${testid}-next`}
      className="flex items-center gap-1 border border-[#D4AF37]/50 text-[#D4AF37] px-4 py-2.5 text-xs font-bold uppercase tracking-widest hover:bg-[#D4AF37] hover:text-black transition-colors duration-200">
      Next <ChevronRight size={15} />
    </button>
    <input type="month" value={month} onChange={(e) => e.target.value && onChange(e.target.value)}
      data-testid={`${testid}-jump`} title="Jump to any month"
      className="bg-[#0F0F0F] border border-white/10 text-white text-sm px-3 py-2.5 rounded-sm focus:outline-none focus:border-[#D4AF37]" />
  </div>
);
